import React from 'react'

const NameField = ({ name, dob }) => {
    return (
        <div className='row my-3'>
            <div className='col-12 col-sm-6 col-md-6 d-flex justify-content-center'>
                <p className='fw-bold field'>
                    {name}
                </p>
            </div>
            <div className='col-12 col-sm-5 col-md-6 d-flex justify-content-center'>
                <p>
                    DOB ({dob})
                </p>
            </div>
        </div>
    )
}

export default NameField